import React from "react"
import "./OfficialMerch.scss"
// import ComingSoonSvg from "@images/coming-soon.svg"
import { StaticImage } from "gatsby-plugin-image"

const OfficialMerch = () => {
  return (
    <>
      <section className="official-merch" id="official-merch">
        <div className="official-merch-inner">
          <div className="official-merch-container">
            <div className="official-merch-container-cover"></div>
            <h2 className="section-title official-merch-title">
              Official <br className="sp-break" /> Merchandise
            </h2>
            <p className="official-merch-text">
              A collection of merchandise commemorating The Mirai Magical School
              Winter Festival and our Mirai Wonderland live concert! These
              goodies were crafted with love and each purchase supports your
              favorite talent and our magical mission! Keep a piece of that
              V4Mirai Winter Magic with you will into the new year and beyond
              with a piece from the Mirai Magical School Winter Festival Merch
              Collection!
            </p>
            <div className="card-items">
              <a
                href="https://shop.bravegroup-us.com/products/b2-tapestry-of-winter-kv-v4advent-calendar-merch"
                className="card-item"
                data-gtm-click="officialMerchandise-item1"
                target="_blank"
                rel="noreferrer"
              >
                <span className="card-item-inner">
                  <span className="card-item-img">
                    <StaticImage
                      src="../../images/merchandise/img-merch-tapestry-winter.jpg"
                      alt="Merchandise"
                    />
                  </span>
                  <p className="card-item-name">B2 Tapestry of Winter KV</p>
                  <p className="card-item-price">$35</p>
                </span>
              </a>
              <a
                href="https://shop.bravegroup-us.com/products/b2-tapestry-of-concert-kv-v4advent-calendar-merch"
                className="card-item"
                data-gtm-click="officialMerchandise-item2"
                target="_blank"
                rel="noreferrer"
              >
                <span className="card-item-inner">
                  <span className="card-item-img">
                    <StaticImage
                      src="../../images/merchandise/img-merch-tapestry-concert.jpg"
                      alt="Merchandise"
                    />
                  </span>
                  <p className="card-item-name">B2 Tapestry of Concert KV</p>
                  <p className="card-item-price">$35</p>
                </span>
              </a>
              <a
                href="https://shop.bravegroup-us.com/products/acrylic-keychain-of-chibis-v4advent-calendar-merch"
                className="card-item"
                data-gtm-click="officialMerchandise-item3"
                target="_blank"
                rel="noreferrer"
              >
                <span className="card-item-inner">
                  <span className="card-item-img">
                    <StaticImage
                      src="../../images/merchandise/img-merch-keychain.jpg"
                      alt="Merchandise"
                    />
                  </span>
                  <p className="card-item-name">Acrylic Keychain of Chibis</p>
                  <p className="card-item-price">$10</p>
                </span>
              </a>
              <a
                href="https://shop.bravegroup-us.com/products/concert-paper-tickets-v4advent-calendar-merch"
                className="card-item"
                data-gtm-click="officialMerchandise-item4"
                target="_blank"
                rel="noreferrer"
              >
                <span className="card-item-inner">
                  <span className="card-item-img">
                    <StaticImage
                      src="../../images/merchandise/img-merch-tickets.jpg"
                      alt="Merchandise"
                    />
                  </span>
                  <p className="card-item-name">Concert Paper Tickets</p>
                  <p className="card-item-price">$20</p>
                </span>
              </a>
              <a
                href="https://shop.bravegroup-us.com/products/blanket-v4advent-calendar-merch"
                className="card-item"
                data-gtm-click="officialMerchandise-item5"
                target="_blank"
                rel="noreferrer"
              >
                <span className="card-item-inner">
                  <span className="card-item-img">
                    <StaticImage
                      src="../../images/merchandise/img-merch-blankets.jpg"
                      alt="Merchandise"
                    />
                  </span>
                  <p className="card-item-name">Blanket</p>
                  <p className="card-item-price">$30</p>
                </span>
              </a>
              <a
                href="https://shop.bravegroup-us.com/products/all-talent-happi-v4advent-calendar-merch"
                className="card-item"
                data-gtm-click="officialMerchandise-item6"
                target="_blank"
                rel="noreferrer"
              >
                <span className="card-item-inner">
                  <span className="card-item-img">
                    <StaticImage
                      src="../../images/merchandise/img-merch-happi.jpg"
                      alt="Merchandise"
                    />
                  </span>
                  <p className="card-item-name">All-Talent Happi</p>
                  <p className="card-item-price">$70</p>
                </span>
              </a>
            </div>
            {/* <div className="coming-soon-img">
              <img src={ComingSoonSvg} alt="coming soon" />
            </div> */}
          </div>
        </div>
      </section>
    </>
  )
}

export default OfficialMerch
